module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"about":"Über Portfolio/Showroom","site-notice":"Impressum","login":"Log In","logout":"Log Out","terms":"Nutzungsbedingungen"}}')
  delete Component.options._Ctor
}
